import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, LOCALE_ID, NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { PagesModule } from "./pages/pages.module";
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { Angulartics2Module } from "angulartics2";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthModule } from "./modules/auth/auth.module";
import {
  LogMissingTranslationsInBackend,
  MultiTranslateHttpLoaderFactory,
} from "./util/translation-utils";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ErrorService } from "./services/errors-service/error.service";
import { RouterModule } from "@angular/router";
import { ComponentsModule } from "./components/components.module";
import { CurrencyPipe, DatePipe, registerLocaleData } from "@angular/common";
import localeDe from "@angular/common/locales/de";
import localeEn from "@angular/common/locales/en";
import localeIt from "@angular/common/locales/it";
import { WebsocketService } from "./services/websocket-service/websocket.service";
import { websocketServiceFactory } from "./services/websocket-service/websocket.service.factory";
import { MatIconModule } from "@angular/material/icon";
import { RootStoreModule } from "./store/root-store.module";
import { AuthGuard } from "./services/auth-guard/auth.guard.service";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MarkdownModule } from "ngx-markdown";
import { NgScrollbarModule } from "ngx-scrollbar";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";

registerLocaleData(localeDe);
registerLocaleData(localeEn);
registerLocaleData(localeIt);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    RouterModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    PagesModule,
    DragDropModule,
    AuthModule.forRoot(),
    Angulartics2Module.forRoot({
      pageTracking: {
        clearIds: true,
      },
    }),
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: MultiTranslateHttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgbModule,
    ComponentsModule,
    MatIconModule,
    NgScrollbarModule,
    RootStoreModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    AuthGuard,
    {
      provide: LOCALE_ID,
      useValue: "de-DE",
    },
    {
      provide: ErrorHandler,
      useClass: ErrorService,
    },
    {
      provide: MissingTranslationHandler,
      useClass: LogMissingTranslationsInBackend,
    },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
    {
      provide: WebsocketService,
      useFactory: websocketServiceFactory,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor(private readonly translate: TranslateService) {
    translate.addLangs(["de", "en", "it"]);
    translate.setDefaultLang("de"); // Fallback-Language
    translate.use("de");
  }
}
